import history from './getHistory';

export default ({
  redirectUrl, condition,
}) => {
  if (condition) {
    return history.push(redirectUrl);
  }
};
